export const socialsData = {
    github: 'https://github.com/ravi-teja-alchuri',
    linkedIn: 'https://in.linkedin.com/in/ravi-teja-alchuri',
    instagram: 'https://www.instagram.com/raviteja.alchuri',
    medium: 'https://medium.com/@raviteja.alchuri',
    facebook: 'https://www.facebook.com/raviteja.india',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    youtube: 'https://www.youtube.com/@raviteja.alchuri'
}